import { lazy, Suspense, useState } from 'react';
import { AppProvider } from './context';
import { useAppContext } from './hooks';
import { Header, BottomNavigation, DesktopSidebar } from './components/layout';
import { LoadingSpinner } from './components/common';
import LoginScreen from './components/auth/LoginScreen';

const Dashboard = lazy(() => import('./components/dashboard/Dashboard'));
const CustomersTab = lazy(() => import('./components/customers/CustomersTab'));
const CustomerDetail = lazy(() => import('./components/customers/CustomerDetail'));
const DispensingTab = lazy(() => import('./components/dispensing/DispensingTab'));
const OrdersTab = lazy(() => import('./components/orders/OrdersTab'));
const InventoryTab = lazy(() => import('./components/inventory/InventoryTab'));
const SettingsTab = lazy(() => import('./components/settings/SettingsTab'));

const AppContent = () => {
  const { state, dispatch } = useAppContext();

  const queueCount = state.dispensingQueue.length;
  const pendingOrders = state.orders.filter(o => o.status !== 'Collected').length;

  const renderActiveTab = () => {
    const props = { state, dispatch };
    switch (state.activeTab) {
      case 'dashboard': return <Dashboard {...props} />;
      case 'customers': return <CustomersTab {...props} />;
      case 'customer-detail': return <CustomerDetail {...props} />;
      case 'dispensing': return <DispensingTab {...props} />;
      case 'orders': return <OrdersTab {...props} />;
      case 'inventory': return <InventoryTab {...props} />;
      case 'settings': return <SettingsTab {...props} />;
      default: return <Dashboard {...props} />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-gray-50 to-blue-50/30 font-sans">
      <Header state={state} dispatch={dispatch} />

      <div className="flex max-w-7xl mx-auto">
        <DesktopSidebar
          activeTab={state.activeTab}
          dispatch={dispatch}
          queueCount={queueCount}
          pendingOrders={pendingOrders}
        />

        <main className="flex-1 p-4 lg:p-6 pb-24 lg:pb-6 max-w-none mx-auto w-full">
          <Suspense fallback={<LoadingSpinner />}>
            <div className="tab-transition" key={state.activeTab}>
              {renderActiveTab()}
            </div>
          </Suspense>
        </main>
      </div>

      <BottomNavigation
        activeTab={state.activeTab}
        dispatch={dispatch}
        queueCount={queueCount}
      />
    </div>
  );
};

const MedFastPharmacy = () => {
  const [authenticated, setAuthenticated] = useState(
    () => sessionStorage.getItem('medfast-auth') === '1'
  );

  if (!authenticated) {
    return <LoginScreen onLogin={() => setAuthenticated(true)} />;
  }

  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
};

export default MedFastPharmacy;
